<template>
<div class="ImgLivePoster">
    <img :src="posterUrl" alt="">
</div>
</template>

<script>
import {getImgLivePoster} from 'api/mLiveApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'ImgLivePoster',
    data() {
        return {
            posterUrl: ''
        }
    },
    mounted() {
        this.findLivePoster()
    },
    methods: {
        findLivePoster() {
            this.setLoading(true)
            var params = {
                innerid: this.$route.query.liveid
            }
            getImgLivePoster({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // console.log(data.data)
                    this.posterUrl = data.data.eventposteratturl
                },
                error: data => {
                    // console.log('error：', data)
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.ImgLivePoster {
    &>img {
        width: 100vw;
    }
}
</style>